<template>
  <v-card flat rounded class="my-2">
    <v-card-text class="text-center pa-8">
      <div v-if="contractorId">
        <v-icon color="success" size="64" class="mb-4">
          mdi-check-circle
        </v-icon>
        <h2 class="headline mb-4">Contractor Created Successfully!</h2>
        <p class="mb-6">
          The contractor has been added to the system with ID: 
          <strong>{{ contractorId }}</strong>
        </p>
      </div>
      <div v-else>
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
          class="mb-4"
        />
        <h2 class="headline mb-4">Creating Contractor...</h2>
        <p class="mb-6">Please wait while we create the contractor.</p>
      </div>
      
      <v-row justify="center" v-if="contractorId">
        <v-col cols="12" md="6">
          <v-btn
            color="primary"
            block
            large
            @click="$emit('new')"
          >
            Add Another Contractor
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
            text
            block
            large
            :to="{ name: 'contractors' }"
          >
            View All Contractors
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ContractorCompleteStep",
  props: {
    contractorId: {
      type: [String, Number],
      default: null
    }
  }
};
</script>